import { useEffect, useState } from 'react';
import axios from 'axios';
import { relatedProductURL } from '../components/assets/constants/Urls/Url';

const RelatedProducts = (id) => {
  const [productData, setProductData] = useState([]); // state to hold product data
  const [isRelatedLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) return; // Prevent fetching if no id is provided

    const fetchProducts = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${relatedProductURL}${id}`);
        setProductData(response.data); // set the product data when the response comes in
      } catch (err) {
        setError(err); // set the error if something goes wrong
      } finally {
        setIsLoading(false); // always set loading to false after fetch
      }
    };

    fetchProducts(); // call the function to fetch products on component mount
  }, [id]); // dependency array includes `id`

  return { productData, error, isRelatedLoading };
};

export default RelatedProducts;
